import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Brand, Service } from '../../types';
import { serviceTypes } from '../../data/serviceTypes';
import ActionButtons from '../shared/ActionButtons';
import LocationSelector from '../booking/LocationSelector';

interface ServiceTypesListProps {
  service?: Service;
  brandName?: string;
  location?: {
    state?: string;
    city?: string;
    area?: string;
  };
}

export default function ServiceTypesList({ service, brandName, location }: ServiceTypesListProps) {
  // If no service is provided, show all service types
  const types = service ? serviceTypes[service.id] || [] : [];

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {brandName ? `${brandName} ` : ''}
            {service ? `${service.name} Services` : 'Appliance Repair Services'}
          </h2>
          <p className="text-lg text-gray-600">
            Professional repair services with expert technicians, same-day service, and 90-day warranty
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {types.map((type) => (
            <div 
              key={type.id}
              className="bg-white rounded-lg border border-gray-200 p-6 hover:border-blue-500 transition-all duration-300 hover:shadow-lg"
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {brandName ? `${brandName} ` : ''}{type.name}
              </h3>
              <p className="text-gray-600 mb-4">
                {type.description}
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="text-sm bg-blue-50 text-blue-700 px-2 py-1 rounded">
                  90-Day Warranty
                </span>
                <span className="text-sm bg-green-50 text-green-700 px-2 py-1 rounded">
                  Same Day Service
                </span>
              </div>
              {location?.city && location?.state && (
                <div className="mt-4 pt-4 border-t border-gray-100">
                  <p className="text-sm text-gray-600">
                    Available in {location.area ? `${location.area}, ` : ''}{location.city}, {location.state}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">
            Book {brandName ? `${brandName} ` : ''}{service ? service.name : 'Appliance Repair'} Service
            {location?.city && ` in ${location.city}, ${location.state}`}
          </h3>
          <p className="text-lg opacity-90 mb-8">
            Our expert technicians are available 24/7 for all types of repairs
          </p>
          <ActionButtons 
            className="justify-center"
            location={location}
          />
        </div>
      </div>
    </div>
  );
}